export default __webpack_public_path__ + "images/RAU-Logo_585fdf5c7393dd562faccddf42693dd2.jpg";